$(function() {
    console.log('location-icon');

    console.log({locationIconsArray});
    for (let i = 0; i < locationIconsArray.length; i++) {
        const location = locationIconsArray[i];
        console.log(location);
        if (location[0] === theme.settings.ipLocation.state) {
            $('.site-header__logo-link').children('img').attr('src', location[1] + '_x100.png?v=1612123595').attr('srcset', location[1] + '_x60.png?v=1612123595 1x,' + location[1] + '_x60@2x.png?v=1612123595 2x');
            return
        }
    }
})